import React from "react";
import Container from "../ui/Container";
import Button from "../ui/Button";
import Chip from "../ui/Chip";
import { BRAND, PRICING } from "../../lib/config";
import { Rocket, ChevronDown } from "lucide-react";

export default function GameHostingHero() {
  return (
    <section className="relative overflow-hidden bg-[#070A0F]">
      {/* clean atmosphere (same language as homepage hero) */}
      <div aria-hidden className="absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(34,211,238,0.18),transparent_55%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_65%,rgba(255,255,255,0.08),transparent_60%)]" />
        <div className="absolute inset-y-0 left-0 w-40 bg-gradient-to-r from-[#070A0F] to-transparent opacity-80" />
        <div className="absolute inset-y-0 right-0 w-40 bg-gradient-to-l from-[#070A0F] to-transparent opacity-80" />
      </div>

      <Container className="relative z-10">
        <div className="grid my-20 items-center py-12">
          <div className="mx-auto w-full max-w-4xl text-center">
            <div className="mb-7 flex flex-wrap items-center justify-center gap-2">
              <Chip>Simple Pricing</Chip>
              <Chip>Automatic backups included</Chip>
              <Chip>DDoS protected</Chip>
            </div>

            <h1 className="text-balance text-5xl font-semibold leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl">
              Game hosting built for
              <span className="block">
                performance<span className="text-cyan-300">.</span>
              </span>
            </h1>

            <p className="mx-auto mt-6 max-w-2xl text-pretty text-base leading-7 text-white/70 sm:text-lg">
              Ryzen-powered nodes, NVMe storage, and transparent resources — so your server stays fast
              when players join, mods load, and ticks matter.
            </p>

            <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Button href="#pricing" className="w-full sm:w-auto">
                Deploy a Server <Rocket className="h-4 w-4 opacity-80" />
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
